import { render, staticRenderFns } from "./ReviewComponent.vue?vue&type=template&id=0eb4f541&scoped=true"
import script from "./ReviewComponent.vue?vue&type=script&lang=js"
export * from "./ReviewComponent.vue?vue&type=script&lang=js"
import style0 from "./ReviewComponent.vue?vue&type=style&index=0&id=0eb4f541&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb4f541",
  null
  
)

export default component.exports